import { FiSearch } from 'react-icons/fi';
import styles from './SearchInput.module.css';

const SearchInput = ({ value, onChange, placeholder = 'Search...', className = '' }) => {
    return (
        <div className={`${styles.searchBox} d-flex align-items-center gap-2 px-3 ${className}`}>
            <FiSearch size={18} className={styles.searchIcon} />
            <input
                type="text"
                className={styles.searchInput}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};

export default SearchInput;
